// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3063cd1f","455":"0e566b54"}[chunkId] + ".chunk.js";
};